export const notificationQueryKeys = {
  all: () => "notification"
};
